// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3H8il","image":"Header_image__2vnvq","name":"Header_name__3uwtC","info":"Header_info__1qB95","infoRow":"Header_infoRow__2DWpI"};